import React from 'react';
import { MetadataItem } from '../../atoms/security/MetadataItemRow';
import { FindingsTable } from '../../molecules/security/FindingsTableV2';

interface SecurityScannerContentProps {
  metadataItems: MetadataItem[];
  isLoading?: boolean;
  severities?: string[];
  categories?: string[];
  searchTerm: string;
  selectedSeverity: string;
  selectedCategory: string;
  currentPage: number;
  totalPages: number;
  pageSize: number;
  startItem: number;
  endItem: number;
  totalFindings: number;
  totalMetadataItems?: number;
  onSearchChange: (value: string) => void;
  onSeverityChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  onImproveWithAI?: (item: MetadataItem) => void;
  isScanning?: boolean;
}

export const SecurityScannerContent: React.FC<SecurityScannerContentProps> = ({
  metadataItems,
  isLoading,
  severities,
  categories,
  searchTerm,
  selectedSeverity,
  selectedCategory,
  currentPage,
  totalPages,
  pageSize,
  startItem,
  endItem,
  totalFindings,
  totalMetadataItems,
  onSearchChange,
  onSeverityChange,
  onCategoryChange,
  onPageChange,
  onPageSizeChange,
  onImproveWithAI,
  isScanning,
}) => {

  return (
    <div className="h-full">
      <FindingsTable
        metadataItems={metadataItems}
        isLoading={isLoading}
        searchTerm={searchTerm}
        selectedSeverity={selectedSeverity}
        selectedCategory={selectedCategory}
        severities={severities}
        categories={categories}
        currentPage={currentPage}
        totalPages={totalPages}
        pageSize={pageSize}
        startItem={startItem}
        endItem={endItem}
        totalFindings={totalFindings}
        totalMetadataItems={totalMetadataItems}
        onSearchChange={onSearchChange}
        onSeverityChange={onSeverityChange}
        onCategoryChange={onCategoryChange}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        onImproveWithAI={onImproveWithAI}
        isScanning={isScanning}
      />
    </div>
  );
};
